import axios from "axios"

import { apiDomain } from "../../store/constants"

const MonthlyProgress = {
    getPlanForEdit (id) {
        return axios({
            url: apiDomain + `api/progress-month/${id}`,
            method: 'GET'
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    updatePlan (payload) {
        return axios({
            url: apiDomain + `api/progress-month/update/${payload.id}`,
            method: 'POST',
            data: payload.data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    getProgressRSP (params) {
        console.log('payload2', params)
        return axios({
            url: apiDomain + `api/progress-month`,
            method: 'GET',
            params

        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
}

export default MonthlyProgress